import { TextNode, $getSelection, $isRangeSelection, $setSelection } from 'lexical';

export function $fixTextNodeSelection(node: TextNode): void {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return;
  }

  const nodeKey = node.getKey();
  const nodeSize = node.getTextContentSize();
  let hasChanges = false;

  const { anchor, focus } = selection;
  if (anchor.key === nodeKey && anchor.offset > nodeSize) {
    anchor.offset = nodeSize;
    hasChanges = true;
  }
  if (focus.key === nodeKey && focus.offset > nodeSize) {
    focus.offset = nodeSize;
    hasChanges = true;
  }

  if (hasChanges) {
    $setSelection(selection);
  }
}
